import { changeVerificationStatus, verifyUser } from '../api/user-api';
import { useState } from 'react';

export const useUserVerification = (externalCallbacks = {}) => {
  const [userForVerification, setUserForVerification] = useState(null);
  const [isUserVerificationModalOpen, setIsUserVerificationModalOpen] =
    useState(false);

  const {
    onLoadingChange,
    onMessageChange,
    onUsersUpdate,
    onLoadUsers,
    onLoadUser,
    onModalClose,
    onVerificationComplete,
  } = externalCallbacks;

  const handleVerifyUser = async (userId, type, shouldVerify) => {
    if (type === 'company' && shouldVerify) {
      setUserForVerification(userId);
      setIsUserVerificationModalOpen(true);
      return { requiresModal: true };
    } else {
      onLoadingChange?.(true);
      try {
        const { data, error } = await changeVerificationStatus(
          userId,
          shouldVerify,
          type
        );

        if (error) {
          onMessageChange?.(error);
          return { error };
        } else {
          onMessageChange?.(data.message);
          onLoadUsers?.();
          onLoadUser?.(userId);
          return { message: data.message };
        }
      } finally {
        onLoadingChange?.(false);
      }
    }
  };

  const handleVerifyCompanyUser = async () => {
    if (!userForVerification) return;

    onLoadingChange?.(true);
    try {
      const { data, error } = await verifyUser(userForVerification, true);

      if (error) {
        onMessageChange?.(error);
        return { error };
      } else {
        onUsersUpdate?.((prev) =>
          prev.filter((user) => user._id !== userForVerification)
        );
        onMessageChange?.(data.message || 'Korisnik verifikovan');
        onLoadUsers?.();
        onLoadUser?.(userForVerification);

        onVerificationComplete?.(true);

        return { message: data.message };
      }
    } finally {
      onLoadingChange?.(false);
    }
  };

  const handleVerifyUserModalClose = () => {
    setIsUserVerificationModalOpen(false);
    setUserForVerification(null);
    onModalClose?.();
  };

  return {
    userForVerification,
    isUserVerificationModalOpen,

    handleVerifyUser,
    handleVerifyCompanyUser,
    handleVerifyUserModalClose,
    setIsUserVerificationModalOpen,
    setUserForVerification,
  };
};
